/// <amd-module name="NetSuite.LogoList.Common.Instrumentation.Helper"/>
define("NetSuite.LogoList.Common.Instrumentation.Helper", ["require", "exports", "NetSuite.LogoList.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ComponentArea = 'SC Logo List';
    var ExtensionVersion = '1.1.1';
    var QueueNameSuffix = '-LogoList';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (container) {
            Instrumentation_1.default.initialize({
                environment: container.getComponent('Environment'),
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                },
            });
        };
        InstrumentationHelper.log = function (activity, subType) {
            var label = activity.replace(' ', '');
            var log = Instrumentation_1.default.getLog(label);
            log.setParameter('activity', activity);
            if (subType) {
                log.setParameter('subType', subType);
            }
            log.submit();
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
